<template>
  <div>
    <div class="row">
      <div class="col-1 col-md-3 col-xl-4 reportModelSep"></div>
      <div class="col-10 col-md-6 col-xl-4 mx-auto">
          <Trapmodal :group="`downlaod-report-modal`" :id="`downlaod-report-modal-id`">
          <div class="card border border-0 pb-0 shadow">
            <div class="card-header">
                <div class="text-white">
                  <div class="col-sm-10 col-md-10 col-lg-10 float-left px-0">
                      Download: Full Daily Activity Report
                  </div>
                  <div class="text-right col-sm-2 col-md-2 col-lg-2 float-left pr-0">
                      <a @click.prevent="$emit('displayModal')" href="javascript:void(0)" id="report-modal-close"><i class="fas fa-times-circle cursorBox"></i></a>
                  </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                  <div class="col-sm-12 col-lg-10 col-xl-12">
                      <fieldset class="form-group" id="__BVID__73">
                        <div tabindex="-1" role="group">
                            <input-product-type :insuranceType="insuranceType"></input-product-type>
                        </div>
                      </fieldset>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-lg-10 col-xl-12 activity-date-picker">
                      <fieldset class="form-group" id="__BVID__73">
                        <div tabindex="-1" role="group">
                            <label for="daterange">
                              Select a Date Range:<br/>
                              <span class="pt-sub-text">This report's data only goes to the past 90 days. Refer to the FTP Transaction Report for more details.</span>
                            </label>
                            <div class="p-0 col-sm-4 col-lg-4 col-xl-4 date-pickers">
                              <div class="field-container from-picker">
                                <form-block :formdata='datePickerFrom'></form-block>
                              </div>
                              <div class="field-container to-picker">
                                <form-block :formdata='datePickerTo'></form-block>
                              </div>
                            </div>
                        </div>
                      </fieldset>
                  </div>
                </div>
                <hr/>
                <div class="row text-center">
                  <div class="col-sm-12">
                      <button @click="downloadDailyActivityReport()" class="btn btn-primary download-template-btn">
                        <i class="fas fa-file-download"></i> <span class="ml-1">Download</span><span v-show="$store.getters.getInlineLoader" class="ml-3"><i class="fas fa-circle-o-notch fa-spin"></i></span>
                      </button>
                      <button @click="cancelDailyActivityReport()" title="Cancel Download" class="btn btn-link text-muted">
                        Cancel Download
                      </button>
                  </div>
                </div>
            </div>
          </div>
          </Trapmodal>
      </div>
      <div class="col-1 col-md-3 col-xl-4 reportModelSep"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment';
import Trapmodal from 'vue-focus-lock';
import Report from '../../services/Report';
import User from '@/services/User';
import FilterDaterange from '../interactive/widgets/FilterDaterange';
import InputProductType from '../interactive/InputProductType';
import filters from '../../../config/admin/filters';
import FormBlock from '../presentational/FormBlock';
import QRP from '../../../config/QRP.env';

export default {
  inject: ['$validator'],
  data() {
    return {
      agencyData: null,
      chartType: {
        field_name: 'clown_field_name_2',
        field_value: 'bar',
        rules: [],
        field_type: 'text',
        help_text: 'Useful 002 help text is nice.',
        values: [
          {
            display_value: 'Bar',
            internal_value: 'bar',
          },
          {
            display_value: 'Horizontal Bar',
            internal_value: 'horizontalBar',
          },
          {
            display_value: 'Polar Area',
            internal_value: 'polarArea',
          },
          {
            display_value: 'Line',
            internal_value: 'line',
          },
        ],
        is_required: false,
        placeholder: null,
        sub_text: null,
      },
      chartDateFilters: {
        field_name: 'dateFilters',
        field_value: '', // Empty string is the value of the placeholder first option
        rules: [],
        field_type: 'select',
        label: 'Choose as many as you would like from this list.',
        help_text: 'You can select many choices here #4.',
        values: filters.dateRange,
        is_required: false,
        is_enabled: true,
        visible: true,
        placeholder: 'Select One',
        sub_text: null,
      },
      dataFilters: {
        dateTo: '',
        dateFrom: '',
        dateRange: (this.$router.currentRoute.query.dateRange ? this.$router.currentRoute.query.dateRange : filters.dateFilterDefaults.reports.reportsDownloadDataFilters),
        columns: [],
        sortBy: '',
        sort: '',
        rowStart: 0,
        rowCount: 10,
        productType: 0,
        format: (this.$router.currentRoute.query.format ? this.$router.currentRoute.query.format : 'csv'), // TODO: Use config values
      },
      filters: filters,
      queryParams: this.$router.currentRoute.query,
      productButtonsData: {},
      insuranceType: {
        field_name: 'insurance_type',
        field_value: '',
        label: 'Filter data by product:',
        rules: [],
        field_type: 'text',
        help_text: '',
        values: [],
        is_required: false,
        is_enabled: true,
        visible: true,
        placeholder: null,
        sub_text: 'Select each product you would like data for.',
        multi_select: true,
      },
      datePickerFrom: {
        field_name: 'dailyActivityFromDate',
        field_value: '',
        rules: [{
          rule: '{ "required": true, "date_format": "MM/DD/YYYY", "within_custom_date_range_reports": [90,1,"days","days","MM/DD/YYYY"], "has_time_between": "low" }',
          rule_name: "RequiredDailyActivityFromDate",
          rule_type: "js",
          rule_url: "",
          trigger: "onblur",
        }],
        field_type: 'date_short',
        label: '',
        help_text: '',
        values: [],
        is_required: true,
        is_enabled: true,
        has_error: false,
        error: '',
        visible: true,
        placeholder: 'MM/DD/YYYY',
        sub_text: null,
      },
      datePickerTo: {
        field_name: 'dailyActivityToDate',
        field_value: '',
        rules: [{
          rule: '{ "required": true, "date_format": "MM/DD/YYYY", "within_custom_date_range_reports": [90,1,"days","days","MM/DD/YYYY"], "has_time_between": "low" }',
          rule_name: "RequiredDailyActivityToDate",
          rule_type: "js",
          rule_url: "",
          trigger: "onblur",
        }],
        field_type: 'date_short',
        label: '',
        help_text: '',
        values: [],
        is_required: true,
        is_enabled: true,
        has_error: false,
        error: '',
        visible: true,
        placeholder: 'MM/DD/YYYY',
        sub_text: null,
      },
    };
  },
  components: {
    Report,
    FilterDaterange,
    InputProductType,
    FormBlock,
    Trapmodal,
  },
  methods: {
    downloadDailyActivityReport() {
      if (this.datePickerFrom.field_value <= this.datePickerTo.field_value) {
        this.$validator.validate('dailyActivityFromDate').then((result) => {
          if (result) {
            this.$validator.validate('dailyActivityToDate').then((result) => {
              if (result) {
                gtag('config', '<%= process.env.GAID %>', { page_path: '/dashboard/daily-activity-report' }); // Add page view to GA
                this.$store.dispatch('setInlineLoader', true);
                this.dataFilters.productType = 0;
                if (this.insuranceType.field_value !== '') {
                  this.dataFilters.productType = this.insuranceType.field_value;
                }
                window.console.info('Requesting Daily Activity Report.');
                Report.requestDailyActivityReport(this.dataFilters)
                  .then(() => {this.$store.dispatch('setInlineLoader', false); return true;});
              } else {
                this.cancelDailyActivityReport();
              }
            })
          } else {
            this.cancelDailyActivityReport();
          }
        })
      } else {
        this.datePickerTo.has_error = true;
        this.datePickerTo.error = 'Invalid Date.'
      }
    },
    cancelDailyActivityReport() {
      this.$store.dispatch('setInlineLoader', false);
      window.console.info('Canceling Daily Activity Report.');
      window.cancel('Canceling Daily Activity Report.'); // Cancel request
    },
  },
  watch: {
    'chartDateFilters.field_value': function(newValue, oldValue) {
      window.console.info("chartDateFilters changed.");
      this.dataFilters.dateRange = newValue;
    },
    'datePickerFrom.field_value': function(newValue, oldValue) {
      let fromDate = moment(new Date(newValue));
      this.dataFilters.dateFrom = fromDate.format('MM/DD/YYYY');
    },
    'datePickerTo.field_value': function(newValue, oldValue) {
      let toDate = moment(new Date(newValue));
      this.dataFilters.dateTo = toDate.format('MM/DD/YYYY');
    }
  },
  mounted() {
    User.init().then((res) => {
      this.productButtonsData = Object.create(this.insuranceType);
      const productOrder = [1, 21, 18, 12, QRP.PRODUCTS.HA_BUNDLE, QRP.PRODUCTS.CA_BUNDLE, QRP.PRODUCTS.RA_BUNDLE];
      if(res.productAccess.includes(QRP.PRODUCTS.AUTO) && res.productAccess.includes(QRP.PRODUCTS.HOME)) {
        res.productAccess.push(QRP.PRODUCTS.HA_BUNDLE);//TODO
      }
      if(res.productAccess.includes(QRP.PRODUCTS.CONDO) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.CA_BUNDLE);//TODO
      }
      if(res.productAccess.includes(QRP.PRODUCTS.RENTERS) && res.productAccess.includes(QRP.PRODUCTS.AUTO)) {
        res.productAccess.push(QRP.PRODUCTS.RA_BUNDLE);//TODO
      }
      if (typeof res.productAccess === 'object') {
        for (let i = 0; i < productOrder.length; i += 1) {
          if (res.productAccess.includes(productOrder[i])) {
            this.productButtonsData.values.push(filters.search_products_with_icons_multiselect[productOrder[i]]);
          }
        }
      } else {
        const productAccessArray = res.productAccess.split(',');

        for (let i = 0; i < productOrder.length; i += 1) {
          if (productAccessArray.includes(productOrder[i])) {
            this.productButtonsData.values.push(filters.search_products_with_icons_multiselect[productOrder[i]]);
          }
        }
      }

      if (res.productAccess.length === 1) {
        this.productButtonsData.field_value = res.productAccess[0].toString(); // the single product is set as the selected one
      }

      this.insuranceType = [];
      this.insuranceType = this.productButtonsData;
    });
  }
};
</script>
<style>
.date-pickers {
  display:flex;
}
.date-pickers i.warning.fas.fa-exclamation-triangle {
    margin-left: 135px;
}
.activity-date-picker .pt-sub-text {
  font-weight: normal;
  color: #545454;
}
.activity-date-picker .field-info {
  display: none;
}
.activity-date-picker .field-messages {
  margin-top: 30px;
}
.activity-date-picker .field-messages .fa-exclamation-triangle {
  display: none;
}
.activity-date-picker .field-messages .text-danger {
  background-color: #FFF !important;
  color: #BB0000 !important;
  font-size: 12px !important;
  padding: 0px !important;
}

#reportsDownloadModal label.btn:focus-within {
  z-index: 1;
  box-shadow: 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  
}
#report-modal-close {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/ReportsDownload.vue?1cc1e637